<div>
  <p-breadcrumb
    class="max-w-full"
    [model]="items"
    [home]="home"
  >
    <ng-template pTemplate="item" let-item>
      <p class="b2 m-b-0">{{ item.label }}</p>
    </ng-template>
    <ng-template pTemplate="separator"> / </ng-template>
  </p-breadcrumb>
</div>
